import _extends from "@babel/runtime/helpers/esm/extends";
/**
 * Google Tag Manager Sender
 *
 * This sender pushes events to the dataLayer to be usable by Google Tag Manager.
 * Its goal is to help teams start migrating events right now to logCenter, in
 * order to get closer to a CDP event implementation, which is the target vision
 * for all client events, all the while still maintaining a connexion to GTM.
 */
export default class GTMSender {
  ensureDataLayerIsReady() {
    if (!window) return false;
    if (!window.dataLayer) {
      window.dataLayer = [];
    }
    return true;
  }
  send(payload, acknowledge) {
    if (!this.ensureDataLayerIsReady()) return;
    const handledLogKeys = [];
    payload.forEach(payloadElement => {
      if (payloadElement.customAttributes) {
        var _window$dataLayer;
        (_window$dataLayer = window.dataLayer) == null || _window$dataLayer.push(_extends({
          event: payloadElement.eventName
        }, payloadElement.customAttributes));
        handledLogKeys.push(payloadElement.uid);
      }
    });
    acknowledge(handledLogKeys);
  }
}
//# sourceMappingURL=index.js.map